export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const PHONE = '+1 910 916 4176';
export const EMAIL = 'b.paxton@andersenlab.com';

export const MEETUP_DATE = '2025-10-15';
export const MEETUP_TIME = '5:30 pm CST';
